export interface EmbeddedMessage {
  type: 'embedded';
}

export interface GetLocationMessage {
  type: 'getLocation';
}

export interface RedirectMessage {
  type: 'redirect';
  payload: {
    url: string;
  };
}

export interface ConfiguratorReadyMessage {
  type: 'configurator_ready';
}

export interface GetDeviceTypeMessage {
  type: 'getDeviceType';
}

export type OutboundMessage =
  | EmbeddedMessage
  | GetLocationMessage
  | ConfiguratorReadyMessage
  | RedirectMessage
  | GetDeviceTypeMessage;

export const embedded = (): EmbeddedMessage => ({ type: 'embedded' });
export const configuratorReady = (): ConfiguratorReadyMessage => ({
  type: 'configurator_ready',
});
export const redirect = (url: string): RedirectMessage => ({
  type: 'redirect',
  payload: { url },
});
export const getLocation = (): GetLocationMessage => ({ type: 'getLocation' });
export const getHostDeviceType = (): GetDeviceTypeMessage => ({
  type: 'getDeviceType',
});
